import { formatCurrency, formatNumber } from '@utils/utils.ts';
import useOverallTokenUsage from '@features/admin-token-usage/hooks/useOverallTokenUsage.tsx';
import styles from './index.module.scss';

function AdminTokenUsageTotals() {
  const { data, isLoading } = useOverallTokenUsage();

  const totalCost = data?.total_cost ?? 0;
  const totalTokens = data?.total_tokens ?? 0;
  const totalDocuments = data?.total_documents ?? 0;
  const totalSuccessDocuments = data?.total_success_documents ?? 0;
  const totalFailedDocuments = data?.total_failed_documents ?? 0;

  return (
    <div className={styles.totalsContainer}>
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <>
          <div>
            Total Cost: <span>{formatCurrency(totalCost, 2)}</span>
          </div>
          <div>
            Total Tokens: <span>{formatNumber(totalTokens)}</span>
          </div>
          <div>
            Total Documents: <span>{formatNumber(totalDocuments)}</span>
          </div>
          <div>
            Total Successful Documents:{' '}
            <span>{formatNumber(totalSuccessDocuments)}</span>
          </div>
          <div>
            Total Failed Documents:{' '}
            <span>{formatNumber(totalFailedDocuments)}</span>
          </div>
        </>
      )}
    </div>
  );
}

export default AdminTokenUsageTotals;
